const trimTrailingSlash = (value) => value?.replace(/\/+$/, "") || "";

const buildBaseUrl = (baseUrl, suffix = "") => {
  const normalizedBase = trimTrailingSlash(baseUrl);
  return normalizedBase ? `${normalizedBase}${suffix}` : "";
};

const userApiRoot =
  process.env.REACT_APP_USER_API_ROOT ||
  process.env.REACT_APP_USER_API_BASE_URL ||
  process.env.REACT_APP_API_ROOT ||
  "";

const userApiBase =
  process.env.REACT_APP_USER_API_URL ||
  process.env.REACT_APP_USER_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  buildBaseUrl(userApiRoot, "/v1/");

const platformApiRoot =
  process.env.REACT_APP_PLATFORM_API_ROOT ||
  process.env.REACT_APP_PLATFORM_API_BASE_URL ||
  process.env.REACT_APP_API_ROOT_EXTERNAL ||
  process.env.REACT_APP_API_URL_EXTERNAL ||
  userApiRoot;

const platformApiBase =
  process.env.REACT_APP_PLATFORM_API_URL ||
  process.env.REACT_APP_PLATFORM_API_BASE_URL ||
  process.env.REACT_APP_API_URL_EXTERNAL ||
  buildBaseUrl(platformApiRoot, "/");

const userWsBase =
  process.env.REACT_APP_USER_WS_URL ||
  process.env.REACT_APP_WS_URL ||
  "";

// Base URL for the public share page.
// Uses /v1/public/posts/{id} because the nginx reverse-proxy on staging routes /v1/** → backend.
// The backend controller is mapped on both /public/posts and /v1/public/posts.
// Fall back to the env override REACT_APP_PUBLIC_SHARE_BASE_URL when provided.
const publicShareBase =
  process.env.REACT_APP_PUBLIC_SHARE_BASE_URL ||
  trimTrailingSlash(userApiBase).replace(/\/+$/, "");

// Builds the full share-page URL, e.g. https://staging.api.socialripple.ai/v1/public/posts/1112
const buildPublicShareUrl = (postId) => {
  if (!postId || !publicShareBase) return null;
  // userApiBase already ends with /v1/ — trim trailing slash then append
  const base = trimTrailingSlash(userApiBase); // e.g. https://staging.api.socialripple.ai/v1
  return `${base}/public/posts/${postId}`;
};

export { platformApiBase, platformApiRoot, userApiBase, userApiRoot, userWsBase, publicShareBase, buildPublicShareUrl };

